module.exports = __webpack_public_path__ + "img/condo-icon.4e18ee94.svg";